<dnv-navigation
  [user]="userStateService.user()"/>
<div
  class="grid h-full grid-cols-6 justify-items-center gap-6 items-center"
  style="grid-template-columns: 1fr 2fr 2fr 2fr 2fr 1fr;"
>
  <div
    class="h-1/8 border-secondary col-start-3 col-end-5 w-fit flex flex-col justify-center rounded-xl border-2 bg-white"
  >
    <div class="p-4 text-center text-gray-500">
      @if (storageStateService.error() && storageStateService.error().status === 403) {
        {{ 'DEFAULT_PAGE.AUTHORIZATION_ERROR' | translate }}
      } @else {
        {{ 'DEFAULT_PAGE.DESCRIPTION' | translate }}
      }
    </div>
  </div>
</div>
